<template>
    <div class="upFile">
      <div v-if="isShowImgList" class="imgList" v-for="(item, idx) in imgList">
        <div class="mg" v-if="showimgmg" @mouseleave="handleMouseLeave">
  <!--        <i @click="showmg=true;dqurl=item.url" class="el-icon-circle-plus-outline" style="margin-right: 20px"></i>-->
          <i class="el-icon-delete" @click="dele(idx)"></i>
        </div>
        <img @contextmenu.prevent="handleRightClick"  @click="showmg=true;dqurl=item.url;dqidx=idx"  :src="item.url" alt="">
      </div>
      <div class="scp" v-if="isShowImgList">
        <span>上传图片</span>
        <input @change="scimg($event)" type="file" accept="image/jpeg,image/jpg,image/png,image/svg/"  multiple>
      </div>
      <!-- <el-button v-if="isShowImgList" style="margin-left: 10px;height: 130px;margin-bottom: 10px;" @click="upPDF" type="info">上传PDF</el-button> -->
      <el-button style="margin-left: 10px;height: 130px;margin-bottom: 10px;" @click="geslimg" :class="!isShowImgList?'ls':''" type="info">历史图片</el-button>
  
      <div class="maximg" v-if="showmg" @click="gb">
        <div class="fn">
          <i @click.stop="zoom+=0.05" class="el-icon-zoom-in"></i>
          <i @click.stop="zoom-=0.05" class="el-icon-zoom-out"></i>
          <i class="el-icon-close"></i>
        </div>
        <span @click.stop="tebimg(1)" class="el-icon-arrow-left z"></span>
        <img @click.stop="" class="imgfd" :style="'transform: scale('+zoom+')'" :src="dqurl" alt="">
        <span @click.stop="tebimg(2)"  class="el-icon-arrow-right y"></span>
      </div>
  
      <div class="maximg" v-if="showlsimg" @click="gb" style="display: block;">
        <div class="fn">
          <i @click.stop="zoom+=0.05" class="el-icon-zoom-in"></i>
          <i @click.stop="zoom-=0.05" class="el-icon-zoom-out"></i>
          <i class="el-icon-close"></i>
        </div>
  
        <div class="lsimg">
          <div v-for="item in lsImgLsit" @click.stop="dqlsimg=item.FullURL">
            <img :src="item.FullURL" :class="item.FullURL == dqlsimg?'xzimg':''" alt="">
            <p style="text-align: center;color: #FFFFFF;">{{item.UFTimeString}}</p>
          </div>
  
        </div>
        <img @click.stop="" class="imgfd" :style="'transform: scale('+zoom+')'" v-if="dqlsimg" :src="dqlsimg" alt="">
  
      </div>
  
    </div>
  </template>
  
  <script>
  import pf from "@/publicFn/baseFn.js"
  export default {
    name: "upFile",
    props: {
      type: '',
      imglists: {
        type: Array(),
        default: () => []
      },
      isShowImgList: {
        default: () => true
      },
      orid: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        zoom: 1,
        showmg: false,
        imgList: [],
        dqurl: '',
        types: '',
        lsImgLsit: [],
        showlsimg: false,
        dqlsimg: '',
        showimgmg: false,
        dqidx: -1
      }
    },
    watch:{
      imglists: {
        deep: true,
        handler(n, o) {
          this.imgList.push(n[n.length-1])
        }
      }
    },
    created() {
      // console.log(this.type)
      if (this.imglists.length) {
        this.imgList = [...this.imglists]
      }
      this.getimglist()
    },
    methods: {
      gb() {
        this.zoom =  1
        this.showmg = false
        this.dqurl = ''
        this.dqlsimg = ''
        this.showlsimg = false
      },
      scimg(e) {
        let files = e.target.files
        let types = this.type
        for (let i = 0; i < files.length; i++) {
          let reader = new FileReader()
         let sum =  this.imgList.length + 1
          reader.readAsDataURL(files[i])
          reader.onload = () => {
            let bas64 = reader.result
            if (files[i].size < 1536000) {
              bas64 = bas64.split(',')[1]
              this.upwj(bas64, sum)
            } else {
              let img = new Image();
  
              let canvas = document.createElement('canvas');
              let context = canvas.getContext('2d');
  
              img.src = bas64
  
              img.onload = () => {
                // console.log(img.width)
                let w = img.width, h = img.height
                canvas.width = w
                canvas.height = h
                context.clearRect(0, 0, w, h)
                context.drawImage(img, 0, 0, w, h)
                bas64 = canvas.toDataURL('image/jpeg', 0.2);
  
                bas64 = bas64.split(',')[1]
  
                this.upwj(bas64, sum)
  
                img = null
              }
            }
          }
  
        }
      },
  
      upwj(bas64, num=1) {
        this._api.publicApi.upFilesDd(bas64, '.jpg', num, this.orid)
        .then(res => {
          if (res) {
            this.imgList.push(res)
          }
        })
      },
  
      dele(idx) {
        // location.reload(true)
  
        this.$confirm('删除后将无法恢复，请确定是否删除?？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        })
        .then(res => {
          let log = this.$loading({
            text: '删除中...'
          })
          this._api.publicApi.deleImg(this.imgList[idx].name)
              .then(res => {
                log.close()
                if (res.DeleteByIdReturn) {
                  this.imgList.splice(idx, 1)
                }
              })
        })
  
  
      },
  
      getimglist() {
        this._api.publicApi.getImgListOrder(this.orid)
            .then(res => {
              // console.log(res)
              let arr = []
              if (res.GetListResult && res.GetListResult.length > 0) {
                for (let i = 0; i < res.GetListResult.length; i++) {
                  this.imgList.push({
                    name: res.GetListResult[i].UFId,
                    url: res.GetListResult[i].FullURL,
                  })
                }
              }
            })
      },
  
      geslimg() {
        this.showlsimg = true
        this._api.publicApi.getLsImg(this.type)
        .then(res => {
          // console.log(res)
          if (res.GetListResult && res.GetListResult.length) {
            this.lsImgLsit = [...res.GetListResult]
          }
        })
      },
  
      upPDF() {
        window.bound.pdfToImg()
        this.pdfHimg()
      },
      pdfHimg() {
        const _this =this
        window.pdfToImgResult = function (result) {
          console.log(result)
          if (result && result.ReportPages) {
            for (let i = 0; i < result.ReportPages.length; i++) {
              _this.upwj(result.ReportPages[i].PageBase64, result.ReportPages[i].PageNumber)
            }
          }
        }
      },
  
      handleRightClick(event) {
        this.showimgmg = true
        event.preventDefault(); // 必须调用
      },
      handleMouseLeave() {
        this.showimgmg = false
      },
  
      tebimg(fx) {
        if (fx == 1) {
          if (this.dqidx == 0) {
            return
          }
          this.dqidx = this.dqidx - 1
          this.dqurl = this.imgList[this.dqidx].url
        }else {
          if (this.dqidx == this.imgList.length-1) {
            return
          }
          this.dqidx = this.dqidx + 1
          this.dqurl = this.imgList[this.dqidx].url
        }
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  .upFile {
    display: flex;
    flex-wrap: wrap;
    cursor: pointer;
    align-items: center;
  }
  .scp {
    width: 130px;
    height: 130px;
    position: relative;
    border: 1px dashed #c6c6c6;
    border-radius: 5px;
    background: #f8f8f8;
    display: flex;
    align-items: center;
    justify-content: center;
    //margin-left: 10px;
    margin-bottom: 10px;
    input {
      opacity: 0;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
    }
    i {
      font-size: 30px;
      font-weight: bold;
      color: #adadad;
    }
  }
  .scp:hover {
    color: #1eb4ff;
    border: 1px dashed #1eb4ff;
  }
  .imgList {
    position: relative;
    margin: 0 10px;
    margin-bottom: 10px;
    img {
      width: 130px;
      height: 130px;
      border-radius: 5px;
    }
    .mg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99;
      background: rgba(0,0,0,0.5);
      display: none;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      font-size: 25px;
    }
    &:hover .mg{
      display: flex;
    }
  }
  .maximg {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.6);
    width: 100vw;
    height: 100vh;
    overflow: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    span {
      color: #fc0000;
      position: absolute;
      font-size: 50px;
    }
    .y {
      top: 50%;
      right: 0;
    }
    .z {
      top: 50%;
      left: 0;
    }
  }
  
  .fn {
    color: #ff0000;
    font-size: 30px;
    position: fixed;
    right: 10px;
    top: 10px;
    z-index: 1000;
    i {
      padding-right: 10px;
    }
  }
  
  //.imgbox {
  //  width: 82vw;
  //  margin: 0 auto;
  //}
  
  .imgfd {
    display: block;
    width: 80vw;
    height: auto;
    margin: 20px auto;
  }
  
  .lsimg {
    width: 90vw;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    margin: auto;
    //margin-bottom: 10px;
    img {
      width: 120px;
      height: 120px;
      margin: 10px;
    }
    .xzimg {
      border: 2px solid #ff0101;
      border-radius: 5px;
    }
  }
  .ls {
    height: auto !important;
    margin-bottom: 0 !important;
  }
  </style>
  